var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import columns from './columns';
export default __assign(__assign({}, columns), { currentPrice: {
        label: 'Preço atual',
        field: 'currentPrice',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, suggestPrice: {
        label: 'Preço aconselhado',
        field: 'suggestPrice',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, currentMargin: {
        label: 'Margem atual',
        field: 'currentMargin',
        type: 'general',
        align: 'left',
        customWidth: 180,
        fixed: false,
        render: true,
        disableOrder: true,
    }, discountCd: {
        label: 'Código de desconto',
        field: 'discountCd',
        type: 'general',
        align: 'left',
        customWidth: 150,
        fixed: false,
        render: true,
        disableOrder: true,
    }, expirationDate: {
        label: 'Data de validade',
        field: 'expirationDate',
        type: 'general',
        align: 'left',
        customWidth: 150,
        fixed: false,
        render: true,
        disableOrder: true,
    }, beepedBy: {
        label: 'price.audit.beepedBy',
        field: 'beepedBy',
        type: 'general',
        align: 'left',
        customWidth: 350,
        fixed: false,
        render: true,
        disableOrder: true,
    } });
